import { NgFor, NgIf } from "@angular/common";
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PQRAlimentacaoEscolarDto } from '../../dtos/pqr-alimentacao-escolar.dto';
import { PQRAlimentacaoEscolarTableCell } from '../../components/alimentacao-escolar/alimentacao-escolar.component';

import { maskitoTransform } from '@maskito/core';
import { mask_dinheiro, mask_mes_ano } from '../../directives/mascaras';

@Component({
  selector: 'app-dialog-pqr-alimentacao-escolar',
  standalone: true,
  imports: [NgFor, MatDialogModule, MatButtonModule, TabelaComponent, NgIf],
  templateUrl: './dialog-pqr-alimentacao-escolar.component.html',
  styleUrl: './dialog-pqr-alimentacao-escolar.component.scss',
})
export class DialogPqrAlimentacaoEscolarComponent implements OnInit {
  @Input() dados: PQRAlimentacaoEscolarDto[] = [];

  dadosTabela: PQRAlimentacaoEscolarTableCell[] = [];

  ngOnInit(): void {
    this.carregarDadosAlimentacao(this.dados);
  }

  carregarDadosAlimentacao(dados: PQRAlimentacaoEscolarDto[]): void {
    this.dadosTabela = dados.map((item: PQRAlimentacaoEscolarDto) => {
      return {
        codPqrAlimentacaoEscolar: item.codPqrAlimentacaoEscolar,
        numeroDiasLetivosAno: item.numeroDiasLetivos,
        valorRefeicao: item.valorRefeicao,
        valorRefeicaoIndigenaQuilombola: item.valorRefeicaoIndigenaQuilombola,
        tipoTurno: item.tipoTurno,
        etapaEnsino: item.etapaEnsino,
      };
    });
  }
}
